import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=5cf2928b&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=ts&"
export * from "./answer.vue?vue&type=script&lang=ts&"
import style0 from "./answer.vue?vue&type=style&index=0&id=5cf2928b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2928b",
  null
  
)

export default component.exports